import { render, staticRenderFns } from "./IP_BasicSummaryPrintable.vue?vue&type=template&id=fd095a78&scoped=true&"
import script from "./IP_BasicSummaryPrintable.vue?vue&type=script&lang=js&"
export * from "./IP_BasicSummaryPrintable.vue?vue&type=script&lang=js&"
import style0 from "./IP_BasicSummaryPrintable.vue?vue&type=style&index=0&id=fd095a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd095a78",
  null
  
)

export default component.exports